<template>
  <div class="walletApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <div class="cash">
      <div class="money">
        <div class="left">充值账号</div>
        <div class="wx">
          <div class="a1"><span>￥</span> 微信充值</div>
          <div class="a2">即时充值，即时到账</div>
        </div>

      </div>

      <div class="cashMoney">
        <div class="title">充值金额</div>

        <div class="setMoney">
          <div class="str">￥</div>
          <input type="number" v-model="price" placeholder="请输入充值金额"/>
         
          
        </div>
        <div class="btn">
          <div class="info">单次充值金额至少100元，最多100000元。</div>
          <button @click="cash">立即充值</button>
        </div>
      </div>
    </div>

    <div class="cashlist">
      <h2>充值记录</h2>
      <ul>
      <li v-for="(item,i) in setCashlist">
        <div class="username">
          <span>{{item.content}}</span>
          <font>{{item.create_time}}</font>
        </div>
        <div class="timer">
          <span>{{item.price}}元</span>
          <font>已到账户</font>
        </div>
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        price:'',
        userData:[],
        setCashlist:[],
        code:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/mpay?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
      
    },
    mounted() {
      this.beforeMount();
      this.getCashlist();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      cash:function(){
        var u = JSON.parse(localStorage.getItem('userjwt'));
        if(this.price < 100){
          this.$alert('输入金额不满足条件，不能充值哦!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/payment',
          data:{
            user_id:u.id,
            price:that.price,
            key:id
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.jsApiCall(data.data);
            }else{
              that.$alert(data.message, '提示', {
                confirmButtonText: '确定'
              });
            }
            
            that.fullscreenLoading = false;
          }
        })
      },

      jsApiCall:function(msg){
        var that = this;
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":'wxa89a20966e69c2a5',
              "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
              "nonceStr":msg.nonceStr, //随机串     
              "package":msg.package,     
              "signType":msg.signType,         //微信签名方式：     
              "paySign":msg.paySign 
            },
            function(res){
                if(res.err_msg == "get_brand_wcpay_request:ok"){
                  that.$alert('充值成功!', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      that.getCashlist();
                    }
                  });
                }else{
                   //返回跳转到订单详情页面
                    alert('支付失败');return false
                }
            }
        );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      getCashlist:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/czList',
          data:{
            key:id
          },
          dataType:'json',
          success:function(data){
            that.setCashlist = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .walletApp{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
  }
  .walletApp .cash{
    width: 94%;
    display: block;
    margin: 0 auto;
    border-radius: 5px;
    background: #fff;
    padding:20px 0
  }
  .walletApp .cash .money{
    margin: 0 auto;
    width:92%
  }
  .walletApp .cash .money::after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  }
  .walletApp .cash .money .left{
    float: left;
    font-size: 16px;
    color: #000;
  }
  .walletApp .cash .money .wx{
    float: left;
    margin-left:15px
  }
  .walletApp .cash .money .wx .a1{
    font-size: 16px;
    color: #000;
    display: block
  }
  .walletApp .cash .money .wx .a1 span{
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #ffca42;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .walletApp .cash .money .wx .a2{
    font-size: 12px;
    color: #666;
    padding-top: 3px;
    display: block;
    padding-left: 22px;
  }
  .walletApp .cash .money a{
    float: right;
    font-size: 15px;
    color: #FF751A;
  }
  .walletApp .cashMoney .title{
    font-size:16px;
    color: #000;
    padding:20px 0 15px 0; 
    width:92%;
    margin:0 auto;
  }
  .walletApp .cashMoney .setMoney{
    position: relative;
    padding-bottom: 10px;
    width:92%;
    margin:0 auto;
  }
  .walletApp .cashMoney .setMoney::before{
    position: absolute;
    content: '';
    background: #f6f6f6;
    height: 1px;
    width: 100%;
    bottom: 0
  }
  .walletApp .cashMoney .setMoney::after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  }
  .walletApp .cashMoney .setMoney .str{
    float: left;
    font-size: 18px;
    color: #000;
    font-weight: bold;
    height:22px;
    line-height:22px;
  }
  .walletApp .cashMoney .setMoney input{
    float: left;
    font-size: 16px;
    color: #000;
    width: 70%;
    margin-left: 5px;
    border:none;
    outline:none;
    height:22px;
  }
  .walletApp .cashMoney .setMoney .all{
    float: right;
    font-size: 15px;
    color: #FF751A;
  }
  .walletApp .cashMoney .btn .info{
    color: #666;
    font-size: 12px;
    width:92%;
    margin:0 auto;
    padding-top:5px
  }
  .walletApp .cashMoney .btn button{
    background: #FF751A;
    width: 92%;
    color: #fff;
    border:none;
    margin:35px auto 15px auto;
    display:block;
    height:38px;
    border-radius: 38px;
    font-size:15px;
  }

  .cashlist{
    width:92%;
    margin:0 auto;
  }
  .cashlist h2{
    font-size:16px;
    padding:15px 0
  }
  .cashlist ul{
    background: #fff;
    width: 100%;
  }
  .cashlist li{
    height: 50px;
    width: 94%;
    margin:0 auto;
    border-bottom: solid 1px #f6f6f6;
    padding-top:10px
  }
  .cashlist li:last-child{
    border-bottom:none;
  }
  .cashlist li img{
    float: left;
    width: 40px;
    border-radius: 50%;
  }
  .cashlist li .username{
    float: left;
    margin-left:10px
  }
  .cashlist li .username font{
    display: block;
    font-size: 12px;
    color: #666;
  }
  .cashlist li .username span{
    display: block;
    font-size: 15px;
    color: #000;
    padding-bottom:3px
  }
  .cashlist li .timer{
    float: right;
  }

  .cashlist li .timer font{
    display: block;
    font-size: 12px;
    color: #666;
    text-align: right
  }
  .cashlist li .timer span{
    display: block;
    font-size: 15px;
    color: #000;
    text-align: right;
    font-weight: bold;
    padding-bottom:3px
  }
</style>